import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { defaultFilters } from '../carousels.utils';

export function TopSellersCarousel(props) {
  const { loading, products } = useDispensaryProducts({
    filters: {
      ...defaultFilters,
      sortBy: `popular`,
      useCache: true,
    },
    perPage: 25,
  });

  // Optional caller-supplied heading, used by the CMS Product Carousel block. See
  // staff-picks-carousel.jsx for why `section.label` is deliberately not used.
  const title = props?.title ?? `Top Sellers`;

  if (!products?.length && !loading) {
    return null;
  }

  return (
    <ProductCarousel
      products={products}
      isLoading={loading}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={title}
      isSmallTitle={props?.isSmallTitle}
      alwaysUseSmallCards={props?.alwaysUseSmallCards}
    />
  );
}
